import {
  Edit,
  SimpleForm,
  ImageInput,
  ImageField,
  TextInput,
  NumberInput,
  BooleanInput,
  Labeled,
  FunctionField,
} from 'react-admin';

const HomeCarouselEdit = (props: any) => (
  <Edit {...props} redirect="list" title="Editar imagem da Home">
    <SimpleForm>
      <Labeled label="Imagem atual">
        <FunctionField
          render={(record: any) =>
            record?.imageUrl ? (
              <img
                src={record.imageUrl}
                alt={record.title || ''}
                style={{ maxWidth: 240, maxHeight: 135, objectFit: 'contain', borderRadius: 4 }}
              />
            ) : (
              <span>--</span>
            )
          }
        />
      </Labeled>
      <ImageInput
        source="imagefile"
        label="Trocar imagem (opcional)"
        accept={{ 'image/*': ['.png', '.jpg', '.jpeg', '.gif', '.webp'] }}
      >
        <ImageField source="src" label="Imagem" />
      </ImageInput>
      <TextInput source="title" label="Título (opcional, usado como alt)" fullWidth />
      <NumberInput source="displayOrder" label="Ordem de exibição" min={0} />
      <BooleanInput source="isActive" label="Ativa" />
    </SimpleForm>
  </Edit>
);

export default HomeCarouselEdit;
